import React, { useState, useEffect } from "react"
import { db } from "../../utils/firebase"
import { fetchStablefordBalance } from "../../utils/stableford"
import "./client.scss"

/**
 * UI components and structure
 */
import Tile from "../../components/structure/tile/tile"
import Title from "../../components/structure/title/title"
import Navigation from "../../components/ui/navigation/navigation"

/**
 * Tabs
 */
import Quotes from "./tabs/quotes"
import Enquiries from "./tabs/enquiries"
import Bookings from "./tabs/bookings"
import Logs from "./tabs/logs"
import Payments from "./tabs/payments"
import Button from "../../components/ui/button/button"

/**
 * Functional component to return a page details the client in question
 */
function Client(props) {
	const [activeTab, setActiveTab] = useState("ENQUIRIES")
	const [client, setClient] = useState({})
	const [stablefordPoints, setStablefordPoints] = useState("Calcuating")

	/**
	 * Deconstruct the client ID from the url params
	 */
	const { id } = props.match.params

	/**
	 * When the ID for the client
	 */
	useEffect(() => {
		/**
		 * Pull the client details down from the database
		 */
		db.doc(`clients/${id}`)
			.get()
			.then((clientDoc) => {
				/**
				 * Make sure teh client document exists
				 */
				if (clientDoc.exists) {
					/**
					 * Push the client data into the state
					 */
					setClient({ ...clientDoc.data() })
				}
			})

		// Work out their available Stableford balance
		fetchStablefordBalance(id).then(({ balance }) => setStablefordPoints(balance))
	}, [id])

	return (
		<Tile>
			<Title>
				<h1>
					{client?.first_name} {client?.last_name}
				</h1>
				<p>
					{client?.email} / {client?.phone}
				</p>
				<p>{stablefordPoints} Stableford Points</p>
			</Title>

			<Navigation
				links={[
					{
						id: "QUOTES",
						label: "Quotes",
					},
					{
						id: "ENQUIRIES",
						label: "Enquiries",
					},
					{
						id: "BOOKINGS",
						label: "Bookings",
					},
					{
						id: "PAYMENTS",
						label: "Payments",
					},
					{
						id: "LOGS",
						label: "Logs",
					},
				]}
				active={activeTab}
				onClick={(tabID) => setActiveTab(tabID)}
			/>

			{activeTab === "QUOTES" && <Quotes clientID={id} />}

			{activeTab === "ENQUIRIES" && <Enquiries clientID={id} />}

			{activeTab === "PAYMENTS" && <Payments clientID={id} />}

			{activeTab === "BOOKINGS" && <Bookings clientID={id} />}

			{activeTab === "LOGS" && <Logs clientID={id} />}
		</Tile>
	)
}

export default Client
